import dataServices from "@/services/dataServices";
import staticFetch from "@/services/staticFetch";
import { error } from "@refinitiv-ui/elements/notification";
import * as XLSX from "xlsx";
import refChangesFields from "@/../public/data/reference-changes.json";
import coraxRefFields from "@/../public/data/corporate-actions-reference-fields.json";
import coraxEventsFields from "@/../public/data/corporate-actions-event-fields.json";
import {
  additionalInformationTypeCodeDescriptionMap,
  adjustmentTypeCodeDescriptionMap,
  amountStatusCodeDescriptionMap,
  creditDebitIndicatorDescriptionMap,
  derivationTypeCodeDescriptionMap,
  dispositionOfFractionsCodeDescriptionMap,
  distributionTaxTypeCodeDescriptionMap,
  distributionTypeCodeDescriptionMap,
  distributionMarkerTypeCodeDescriptionMap,
  eventActionCodeDescriptionMap,
  eventStageCodeDescriptionMap,
  eventTypeCodeDescriptionMap,
  mandatoryVoluntaryIndicatorDescriptionMap,
  meetingAgendaTypeCodeDescriptionMap,
  meetingStatusCodeDescriptionMap,
  meetingTypeCodeDescriptionMap,
  meetingWebcastTypeCodeDescriptionMap,
  offerTypeCodeDescriptionMap,
  optionTypeCodeDescriptionMap,
  paymentFrequencyDescriptionMap,
  processingStatusDescriptionMap,
  processingTypeCodeDescriptionMap,
  qdiEligibilityCodeDescriptionMap,
  renounceableStatusDescriptionMap,
  sourceOfFundsCodeDescriptionMap,
  typeCodeDescriptionMap,
} from "@/app/maps/corporate-actions-maps";

export default {
    postQueryExecution(payload) {
      this.loading = true
      let chacheHashKey = this.hashCode(JSON.stringify(payload))
      console.log(chacheHashKey)
      let storedItem = localStorage.getItem(chacheHashKey)
      if(storedItem == null || new Date().getTime() > JSON.parse(storedItem)["expiry"] + 86400000){
        dataServices.queryExecution(payload).then((data) => {
        if(data["status"] == "OK"){
          this.getQueryResult(data["data"]["result"], chacheHashKey)    
        }else{
          this.loading = false
          console.log("error data",data)
          if(data["status"] == "ERROR"){
            error(data["data"])
          }else if("Message" in data["data"]){
            error(data["data"]["Message"])
            if(data["data"]["Message"] == "User is not authorized to access this resource with an explicit deny"){
              this.accessGranted = false
            }
          }else{
            try {
              error(data["data"]["error"]["errorMessage"])
              // error(data)
            } catch (e) {
              error(data)
              console.error("Error parsing error message:", e)
            }
          }
          this.loading = false
          return []
        }
      })
      }else{
        this.returnResult(JSON.parse(storedItem)["data"], chacheHashKey, true)
      }
    },

    getQueryResult(result_id, hashKey){
      dataServices.queryResult(result_id).then((result) => {
        console.log( result["data"])
        if(result["data"]["result"]["status"] == "SUCCEEDED"){
          this.returnResult(result["data"]["result"]["data"], hashKey, false)
        }else{
          setTimeout(() => 
            this.getQueryResult(result_id, hashKey), 
            this.query_request_delay
          );
        }
      })
    },

    returnResult(result, hashKey, cached){
      // if(this.refPromise>0 && result.length==0){
      //   this.requestType = "refChanges"
      // }
      console.log("result",this.requestType);
      if(!cached){
        let v = {
          "data": result,
          "expiry": new Date().getTime()
        }
        localStorage.setItem(hashKey, JSON.stringify(v));
      }
      if(this.requestType == "equity"){
        this.equityData = result
        this.renderInstrumentsGrid()
        document.getElementById("export-toggle-btn").disabled = false
        document.getElementById("export-drpdwn").disabled = false
        document.getElementById("export-btn").disabled = false
        const tree = document.getElementById("ex-tree")
        let rics = [];
        for(let ins of result){
          rics.push({ label: ins["int_ric"]+" - "+ins["int_security_description"], value: ins["int_ric"]+","+ins["int_issue_perm_id"]+","+ins["int_quote_perm_id"] })
        }
        tree.data = rics
        this.loading = false
      }else if(this.requestType == "reference"){
        this.refPromise -= 1
        this.refFieldsData = result
        this.requestType = "refChanges"
      }else if(this.requestType == "refChanges"){
        this.refPromise -= 1
        this.requestType = "reference"
        this.refChangesData = result;
        this.renderReferenceChangesGrid()
        this.loading = false
      }else if(this.requestType == "pricing"){
        this.promiseFlag -= 1
        if(this.promiseFlag == 1){
          this.pricingData = result
        }else if(this.promiseFlag == 0){
          this.pricingData = this.pricingData.concat(result)
          if (this.pricingData.length > 0) {
            this.renderPricingGrid()
          }else{
            this.loading = false;
          }
        }
      }else if(this.requestType == "exportProcessedReference"){
        this.refPromise -= 1
        if(this.refPromise == 1){
          this.exportRefData = result
          this.requestType = "exportProcessedRefChanges"
        }else if(this.refPromise == 0){
          this.exportRefData = this.exportRefData.concat(result)
        }
      }else if(this.requestType == "exportProcessedRefChanges"){
        this.refPromise -= 1
        if(result.length>0){
          const items = []
          const fields = refChangesFields
          var refData = this.exportRefData.pop()
          for (let d of result) {
            fields.forEach(function (field){
              if(d["ref_"+field+"_change_flag"] == "Y"){  
                items.push([
                  field,
                  d["ref_"+field]
                ])
              }
            })
          }
          for(let item of items){
            refData["int_"+item[0]] = item[1]
          }
          this.exportRefData = this.exportRefData.concat([refData])
        }
        this.exportPricingData(this.exportQuotes)
      }else if(this.requestType == "exportDeltaReference"){
        this.exportRefData = result
        this.exportPricingData(this.exportQuotes)
      }else if(this.requestType == "exportProcessedCoraxReference"){
        this.refPromise -= 1
        this.exportCoraxRefData = result
        this.requestType = "exportProcessedCoraxRefChanges"
      }else if(this.requestType == "exportProcessedCoraxRefChanges"){
        this.refPromise -= 1
        if(result.length>0){
          const items = []
          const fields = coraxRefFields
          let refData = this.exportCoraxRefData.pop()
          for (let d of result) {
            fields.forEach(function (field){
              if(d["xrd_"+field+"_change_flag"] == "Y"){  
                items.push([
                  field,
                  d["xrd_"+field]
                ])
              }
            })
          }
          for(let item of items){
            refData["xri_"+item[0]] = item[1]
          }
          this.exportCoraxRefData = this.exportCoraxRefData.concat([refData])
        }
        this.exportProcessedCoraxEvents(this.exportIssues, this.exportQuotes)
      }else if(this.requestType == "exportProcessedCoraxEvents"){
        this.refPromise -= 1
        this.exportCoraxEventsData = result
        this.requestType = "exportProcessedCoraxEventChanges"
      }else if(this.requestType == "exportProcessedCoraxEventChanges"){
        this.refPromise -= 1
        if(result.length>0){
          const items = []
          const fields = coraxEventsFields
          let refData = this.exportCoraxEventsData.pop()
          for (let d of result) {
            fields.forEach(function (field){
              if(d["xdd_"+field+"_change_flag"] == "Y"){  
                items.push([
                  field,
                  d["xdd_"+field]
                ])
              }
            })
          }
          for(let item of items){
            refData["xdi_"+item[0]] = item[1]
          }
          this.exportCoraxEventsData = this.exportCoraxEventsData.concat([refData])
        }
        this.exportPricingData(this.exportQuotes)
      }else if(this.requestType == "exportDeltaCoraxReference"){
        this.exportCoraxRefData = result
        this.exportDeltaCoraxEvents(this.exportIssues)
      }else if(this.requestType == "exportDeltaCoraxEvents"){
        this.exportCoraxEventsData = result
        this.exportPricingData(this.exportQuotes)
      }else if(this.requestType == "exportPricing"){
        this.promiseFlag -= 1
        if(this.promiseFlag == 1){
          this.exPricingData = result
        }else if(this.promiseFlag == 0){
          this.exPricingData = this.exPricingData.concat(result)
          let dataToggle = document.getElementById("change-data-toggle")
          const workbook = XLSX.utils.book_new();
          if(dataToggle.checked){
            const worksheet2 = XLSX.utils.json_to_sheet(this.exportRefData);
            XLSX.utils.book_append_sheet(workbook, worksheet2, "Reference");
          }else{
            const worksheet2 = XLSX.utils.json_to_sheet(this.exportCoraxRefData);
            XLSX.utils.book_append_sheet(workbook, worksheet2, "Corax Reference");
            const worksheet3 = XLSX.utils.json_to_sheet(this.exportCoraxEventsData);
            XLSX.utils.book_append_sheet(workbook, worksheet3, "Corax Events");
          }
          const worksheet = XLSX.utils.json_to_sheet(this.exPricingData);
          XLSX.utils.book_append_sheet(workbook, worksheet, "Price");
          XLSX.writeFile(workbook, new Date().toISOString()+".xlsx");
        }
        this.loading = false
      } else if (this.requestType === "corporate actions reference") {
        console.log("corporate actions reference result", result);

        // Determine query reference or changes
        let xriKeyCount = 0;
        let xrdKeyCount = 0;

        result.forEach(item => {
          Object.keys(item).forEach(key => {
            const lk = key.toLowerCase();
            if (lk.startsWith('xri')) xriKeyCount++;
            else if (lk.startsWith('xrd')) xrdKeyCount++;
          });
        });

        const isXRI = xriKeyCount > xrdKeyCount;
        const isXRD = xrdKeyCount > xriKeyCount;

        console.log('isXRD:', isXRD);
        console.log('isXRI:', isXRI);

        if (isXRI) {
          this.equityCorporateActionsReferenceEventFields = result.map(item => ({
            xri_event_id: item.xri_event_id || "",
            xri_last_update_date: item.xri_last_update_date || "",
          }));
          this.equityCorporateActionsReferenceEventFields = result
          this.equityCorporateActionsReferenceQueryResult = result;
          this.renderCorporateActionsReferenceEventsGrid();
        }
        if (isXRD){
          this.equityCorporateActionsReferenceFieldChangesQueryResult = result;
          this.renderCorporateActionsReferenceChangesGrid();
        }


      this.loading = false;
    } else if (this.requestType === "corporate actions events") {

this.equityCorporateActionsEventItems = result.map(item => ({
        ...item,
        xdi_additional_information_1_type_code: additionalInformationTypeCodeDescriptionMap[item.xdi_additional_information_1_type_code] || item.xdi_additional_information_1_type_code || "",
        xdi_additional_information_2_type_code: additionalInformationTypeCodeDescriptionMap[item.xdi_additional_information_2_type_code] || item.xdi_additional_information_2_type_code || "",
        xdi_adjustment_type_code: adjustmentTypeCodeDescriptionMap[item.xdi_adjustment_type_code] || item.xdi_adjustment_type_code || "",
        xdi_amount_status_code: amountStatusCodeDescriptionMap[item.xdi_amount_status_code] || item.xdi_amount_status_code || "",
        xdi_derivation_type_code: derivationTypeCodeDescriptionMap[item.xdi_derivation_type_code] || item.xdi_derivation_type_code || "",
        xdi_credit_debit_indicator: creditDebitIndicatorDescriptionMap[item.xdi_credit_debit_indicator] || item.xdi_credit_debit_indicator || "",
        xdi_disposition_of_fractions_code: dispositionOfFractionsCodeDescriptionMap[item.xdi_disposition_of_fractions_code] || item.xdi_disposition_of_fractions_code || "",
        xdi_distribution_tax_type_code: distributionTaxTypeCodeDescriptionMap[item.xdi_distribution_tax_type_code] || item.xdi_distribution_tax_type_code || "",
        xdi_distribution_type_code: distributionTypeCodeDescriptionMap[item.xdi_distribution_type_code] || item.xdi_distribution_type_code || "",
        xdi_event_action_code: eventActionCodeDescriptionMap[item.xdi_event_action_code] || item.xdi_event_action_code || "",
        xdi_event_stage_code: eventStageCodeDescriptionMap[item.xdi_event_stage_code] || item.xdi_event_stage_code || "",
        xdi_event_type_code: eventTypeCodeDescriptionMap[item.xdi_event_type_code] || item.xdi_event_type_code || "",
        xdi_mandatory_voluntary_indicator: mandatoryVoluntaryIndicatorDescriptionMap[item.xdi_mandatory_voluntary_indicator] || item.xdi_mandatory_voluntary_indicator || "",
        xdi_meeting_type_code: meetingTypeCodeDescriptionMap[item.xdi_meeting_type_code] || item.xdi_meeting_type_code || "",
        xdi_offer_type_code: offerTypeCodeDescriptionMap[item.xdi_offer_type_code] || item.xdi_offer_type_code || "",
        xdi_option_type_code: optionTypeCodeDescriptionMap[item.xdi_option_type_code] || item.xdi_option_type_code || "",
        xdi_payment_frequency: paymentFrequencyDescriptionMap[item.xdi_payment_frequency] || item.xdi_payment_frequency || "",
        xdi_processing_status: processingStatusDescriptionMap[item.xdi_processing_status] || item.xdi_processing_status || "",
        xdi_processing_type_code: processingTypeCodeDescriptionMap[item.xdi_processing_type_code] || item.xdi_processing_type_code || "",
        xdi_qdi_eligibility_code: qdiEligibilityCodeDescriptionMap[item.xdi_qdi_eligibility_code] || item.xdi_qdi_eligibility_code || "",
        xdi_renounceable_status: renounceableStatusDescriptionMap[item.xdi_renounceable_status] || item.xdi_renounceable_status || "",
        xdi_source_of_funds_code: sourceOfFundsCodeDescriptionMap[item.xdi_source_of_funds_code] || item.xdi_source_of_funds_code || "",
        xdi_type_code: typeCodeDescriptionMap[item.xdi_type_code] || item.xdi_type_code || "",
        xdi_meeting_status_code: meetingStatusCodeDescriptionMap[item.xdi_meeting_status_code] || item.xdi_meeting_status_code || "",
        xdi_meeting_webcast_type_code: meetingWebcastTypeCodeDescriptionMap[item.xdi_meeting_webcast_type_code] || item.xdi_meeting_webcast_type_code || "",
        xdi_meeting_agenda_type_code: meetingAgendaTypeCodeDescriptionMap[item.xdi_meeting_agenda_type_code] || item.xdi_meeting_agenda_type_code || "",
        xdi_distribution_marker_type_code: distributionMarkerTypeCodeDescriptionMap[item.xdi_distribution_marker_type_code] || item.xdi_distribution_marker_type_code || "",

        int_ric: this.selectedGlobalRIC || "",
      }));
      this.loading = false;
      this.renderCorporateActionsEventsGrid();
    }

    this.equityCorporateActionsEventItems = (this.equityCorporateActionsEventItems || []).filter(item => {
      const keysToCheck = [
        "xdi_adjusted_declared_dividend_amount",
        "xdi_declared_dividend_amount",
        "xdi_payment_frequency",
        "xdi_distribution_marker_type_code",
        "xdi_source_of_funds_code",
        "xdi_payment_date",
        "xdi_reinvestment_price",
        "xdi_announcement_date",
        "xdi_effective_date",
        "xdi_payment_date",
        "xdi_existing_securities_quantity",
        "xdi_additional_information_1",
        "xdi_additional_information_2",
        "xdi_event_action_code",
        "xdi_processing_status",
        "xdi_processing_type_code",
        "xdi_rescinded_date",
      ];

      let emptyCount = 0;
      for (const k of keysToCheck) {
        const v = item[k];

        const isEmpty =
          v === null ||
          v === undefined ||
          (typeof v === "string" && v.trim() === "") ||
          (Array.isArray(v) && v.length === 0) ||
          (typeof v === "object" && !Array.isArray(v) && Object.keys(v).length === 0);

        if (isEmpty) emptyCount++;
      }

      // Exclude items where ALL specified keys are empty
      console.log("emptyCount", emptyCount);
      return emptyCount < 17;
    });
    },
    async loadMockData () {
      const equityReferenceFields = await staticFetch.retrieveStaticData(`data/reference-fields.json`)
      this.equityReferenceFields = equityReferenceFields
      // this.sampleEquityReferenceChanges = this.generateEquityReferenceChangesItems()
      const equityCorporateActionsReferenceFields = []
      this.equityCorporateActionsReferenceFields = equityCorporateActionsReferenceFields
      this.sampleEquityCorporateActionsReferenceChanges = this.generateEquityCorporateActionsReferenceChangesItems(this.getRandomInt(3, 5))
      const equityCorporateActionsEventFields = await staticFetch.retrieveStaticData(`data/corporate-actions-event-fields.json`)
      this.equityCorporateActionsEventFields = equityCorporateActionsEventFields
      this.sampleEquityCorporateActionsEventChanges = this.generateEquityCorporateActionsEventChangesItems(this.getRandomInt(5, 10))
    }
}